<template>
    <div class="w-full border mt-2">
        <table class="w-full border-collapse border border-theme-border">
            <thead>
                <tr class="bg-brand-blue text-white">
                    <th
                        class="w-1/3 p-2 border border-theme-border text-center"
                    >
                        <div class="flex justify-center items-center h-20">
                            <span>Unidades mínimas </span>
                        </div>
                    </th>
                    <th
                        class="w-1/3 p-2 border border-theme-border text-center"
                    >
                        <div class="flex justify-center items-center h-20">
                            <span>Horas de entrega adicional</span>
                        </div>
                    </th>
                    <th
                        class="w-1/3 p-2 border border-theme-border text-center"
                    >
                        <div class="flex justify-center items-center h-20">
                            <span>Costo adicional de entrega</span>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in itemsTemp" :key="item.min">
                    <th
                        class="text-center font-normal border border-theme-border p-2"
                    >
                        <custom-input
                            v-if="item.min !== 1"
                            id="min_"
                            v-model="item.min"
                            class="w-full bg-theme-canvas text-theme-base"
                            type="number"
                            autocomplete="off"
                            min="2"
                        />
                        <span v-else class="text-theme-base">
                            1 <small> * Valor requerido </small>
                        </span>
                    </th>
                    <th
                        class="text-center font-normal border border-theme-border p-2"
                    >
                        <custom-input
                            id="deliveryHours_"
                            v-model="item.deliveryHours"
                            class="w-full bg-theme-canvas text-theme-base"
                            type="number"
                            min="0"
                            autocomplete="off"
                            @blur="onInput"
                        />
                    </th>
                    <th class="border border-theme-border p-2">
                        <input-money-component
                            v-model="item.deliveryPrice"
                            enabled
                            class="w-full bg-theme-canvas text-theme-base"
                            label=""
                            @blur="onInput"
                        />
                    </th>
                    <th class="p-0 m-0 border border-theme-border">
                        <button
                            v-if="item.min !== 1"
                            class="flex p-0 h-20 items-center justify-center bg-transparent border-0 text-theme-danger hover:opacity-80"
                            @click="deleteItemFromIndex(index)"
                        >
                            <small> ❌ </small>
                        </button>
                    </th>
                </tr>
            </tbody>
        </table>

        <div class="flex justify-center">
            <custom-tooltip bottom border>
                <app-button icon border @click="addNewItem"> ➕ </app-button>
                <template #tooltip> Nuevo rango</template>
            </custom-tooltip>
        </div>
    </div>
</template>

<script>
import CustomInput from "@/components/utils/CustomInput.vue";
import InputMoneyComponent from "@/components/utils/InputMoneyComponent.vue";

export default {
    name: "DeliveryConfigurationByUnitsEditor",
    components: { CustomInput, InputMoneyComponent },
    model: {
        prop: "itemsCurrent",
        event: "change"
    },
    props: {
        itemsCurrent: {
            type: Array,
            default: () => [{ max: 1, deliveryPrice: 1000, deliveryHours: 1 }],
            required: true
        }
    },
    emits: ["change"],
    data: () => ({
        itemsTemp: []
    }),
    watch: {
        itemsCurrent(value) {
            this.setInput(value);
        }
    },
    mounted() {
        this.setInput(this.itemsCurrent);
    },
    methods: {
        addNewItem() {
            const item = this.itemsTemp.at(-1);
            this.itemsTemp.push({
                min: Number(item.min) + 1,
                deliveryPrice: item.deliveryPrice * 2,
                deliveryHours: item.deliveryHours * 2
            });
            this.$emit("change", this.itemsTemp);
        },
        deleteItemFromIndex(fromIndex) {
            this.itemsTemp.splice(fromIndex, 1);
            this.onInput();
        },
        setInput(value) {
            this.itemsTemp = [...value];
        },
        onInput() {
            this.$emit("change", this.itemsTemp);
        }
    }
};
</script>
